import styled from 'styled-components';
import { lighten } from 'polished';
import { Link } from 'react-router-dom';
//
import colors from 'theme/colors';
import ButtonSimple from 'components/buttons/simple';

export const { darkInputBorder, disabledFont, error, platinum60, primary, darkBorder, lightBorder } = colors;

export const Container = styled.div`
  width: 100%;
`;

export const IconWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 16px 32px 0px 32px;
  cursor: pointer;
`;
export const EditIconWrap = styled.div`
  display: flex;
  align-items: center;
  color: ${primary};
  border: 1px solid ${primary};
  border-radius: 3px;
  padding: 8px 16px;
  svg {
    width: 12px;
  }
`;

export const EditText = styled.span`
  padding-right: 18px;
  font-size: 14px;
  font-weight: 600;
`;

export const DealWrap = styled.div`
  display: flex;
  align-items: center;
  svg {
    color: ${primary};
    padding-right: 10px;
    font-size: 3em;
  }
`;
export const AddDealText = styled.span`
  font-size: 10px;
  color: #000;
`;
export const ActionBar = styled.div`
  background-color: white;
  box-shadow: 0 1px 3px 0 rgba(32, 33, 36, 0.3);
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 32px;
`;

export const ShareButton = styled(ButtonSimple)`
  height: 34px;
  margin-left: 8px;
`;

export const DealDetails = styled.td`
  background: #ededed;
  border-radius: 2px;
  text-align: left;
`;
export const TableDataContent = styled.div`
  display: grid;
  grid-template-rows: 50px 30px 40px 40px;
  grid-gap: 10px;
`;
export const CustomerText = styled.p`
  color: #1c73ff;
  font-size: 14px;
  text-transform: capitalize;
  padding-top: 16px;
  padding-bottom: 8px;
  width: 210px;
`;

export const StyledLink = styled(Link)`
  padding-bottom: 8px;
  font-weight: 500;
  text-transform: capitalize;
`;

export const PaddingBox = styled.div`
  padding-bottom: 8px;
`;
export const SmallText = styled.p`
  font-size: 12px;
`;
export const PeriodText = styled.span`
  font-size: 14px;
  padding-right: 4px;
  font-weight: 500;
`;

export const SmallFontText = styled.span`
  font-size: 12px;
`;

export const StatusValueText = styled.p`
  font-weight: 500;
  text-transform: capitalize;
`;

export const DescriptionText = styled.td`
  font-size: 12px;
  color: rgba(60, 60, 67, 0.6) !important;
  font-weight: 300 !important;
`;

export const DescriptionValue = styled.td`
  background: #f7f7f7;
`;
export const ComparisonTable = styled.table`
  background-color: white;
  margin: 5px 64px;
  border-spacing: 1em 0;
  display: flex;
  justify-content: flex-start;

  tbody:nth-of-type(2) {
    display: flex;
    border: 1px solid ${platinum60};
    border-radius: 3px;

    tr {
      display: flex;
      justify-content: center;
      align-items: center;

      td {
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
  }

  tr td {
    word-break: break-word;
    text-align: left;
  }

  tr:first-child td:first-child {
    border: none;
  }

  tr:nth-child(even) {
    background-color: ${platinum60};
  }

  td {
    width: 208px;
    padding: 8px 16px;
    border: 1px solid ${platinum60};
    text-align: center;

    .customer-name {
      font-weight: 500;
    }
  }

  p {
    margin: 0;
  }

  td:nth-of-type(1) {
    border: none !important;
    text-align: left;
    background-color: #f7f7f7;
    font-weight: 600;
    min-width: 305px;
    color: #303641;
  }
`;

const colorGradient = 0.3;

export const AddDealTBody = styled.tbody`
  color: ${lighten(colorGradient, primary)};
  transition: color 0.2s ease;

  &:hover {
    color: ${primary};
    cursor: pointer;
  }
`;

export const AddDealCell = styled.td`
  display: flex;
  height: 100%;
  padding: 0;
`;

export const DescriptionCell = styled.td`
  padding: 8px 16px !important;
  background-color: white !important;
  border-top: 1px solid ${platinum60} !important;
`;

export const DealDescription = styled.p`
  font-style: italic;
  margin: 0;
  white-space: pre-line;
`;

export const ProductsCell = styled.td`
  padding: 8px 16px !important;
`;

export const SpacerCell = styled.td`
  height: 54px !important;
`;

export const Button = styled.button`
  padding: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: transparent;
  border: none;
  transition: color 0.2s ease;

  &:disabled {
    color: ${disabledFont} !important;
  }

  &:hover {
    cursor: pointer;

    &:disabled {
      cursor: not-allowed;
    }
  }
`;

const lightenValue = 0.2;

export const ArrowButton = styled(Button)`
  color: ${primary};
  :hover {
    color: ${lighten(lightenValue, primary)};
  }
`;

export const CloseButton = styled(Button)`
  color: ${error};
  margin-left: 32px;
  margin-right: 32px;
  :hover {
    color: ${lighten(lightenValue, error)};
  }
`;

export const ArrowContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  padding: 8px;
`;

export const SearchHeader = styled.div`
  display: flex;
  margin-bottom: 8px;
`;

export const SearchType = styled.select`
  border: 1px solid ${darkInputBorder};
  border-radius: 3px;
  margin-right: 8px;
  padding: 14px 16px;
`;

export const SelectContainer = styled.div`
  background-color: white;
  border: 1px solid ${darkInputBorder};
  border-radius: 3px;
  display: flex;
  margin-right: 8px;
  padding: 0px 8px 0px 16px;
  width: 118px;
  height: 48px;

  & > div {
    width: 100%;
  }

  .MuiInput-underline:hover:not(.Mui-disabled):before,
  .MuiInput-underline:before {
    border-bottom: none;
  }
`;

export const ToggleButtonContainer = styled.div`
  display: flex;

  & > div {
    margin-right: 16px;
  }
`;

export const Blanktd = styled.td`
  background-color: white !important;
`;

export const SubHeaderData = styled.td`
  color: rgba(60, 60, 67, 0.6) !important;
  font-weight: 400 !important;
`;

export const WeightHeader = styled.span`
  color: rgba(60, 60, 67, 0.6);
  font-size: 14px;
  padding-left: 5px;
`;

export const UnitToggle = styled.td`
  background-color: white !important;
  padding-bottom: 16px !important;
  padding-left: 0px !important;
`;
export const CostToServeData = styled.td`
  background-color: white !important;
  border: 1px solid ${platinum60} !important;
`;

export const CostToServeBottom = styled.td`
  border-bottom: 2px solid ${darkBorder} !important;
`;

export const CostToServeTop = styled.td`
  border-top: 2px solid ${darkBorder} !important;
`;

export const CreditBottom = styled.td`
  border-bottom: 2px solid ${darkBorder} !important;
  background-color: #f7f7f7 !important;
`;

export const CreditTermData = styled.td`
  background-color: #f7f7f7;
  border: 0.5px solid ${lightBorder} !important;
`;

export const DescriptionWhiteValue = styled(DescriptionValue)`
  background-color: white;
`;
export const GrayBackground = styled.td`
  background-color: #f7f7f7;
`;
export const DescriptionBorder = styled(DescriptionWhiteValue)`
  border-bottom: 2px solid ${darkBorder} !important;
`;
